"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopy = void 0;
/* eslint-disable energy-cx/nebula-imports */
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
exports.useCopy = (0, ui_tools_1.createUseCopy)({
    Em: nebula_1.Em,
    Li: nebula_1.Li,
    LineThrough: nebula_1.LineThrough,
    Ol: nebula_1.Ol,
    P: nebula_1.P,
    Small: nebula_1.Small,
    Strong: nebula_1.Strong,
    Sub: nebula_1.Sub,
    Sup: nebula_1.Sup,
    TextLink: nebula_1.TextLink,
    Ul: nebula_1.Ul,
});
